/*
================================================================================

  ANIMATIONS

================================================================================
*/

import $ from 'jquery';

const Animations = (() => {

	const init = function() {

		var windowHeight = $(window).innerHeight()/1.5
		function inViewport(){

			$(".jsfadeinRow").each(function(){
			  var divPos = $(this).offset().top;
			  var topOfWindow = $(window).scrollTop();
			  if (divPos < topOfWindow + windowHeight) {
				// console.log("hello")
				$(this).children('.jsfadeinRow__item').each(function (index) {
				  var $this = $(this);
				  setTimeout(function () {
					$this.addClass('jsfadeinRow--active');
				  }, 250 * index );
				});
			  }
			});

			$(".jsfadein").each(function(){
				var divPos = $(this).offset().top;
				var topOfWindow = $(window).scrollTop();
					if (divPos < topOfWindow + 400) {
						$(this).addClass("jsfadein--active");
					}
			});
		  }

		  inViewport();

		  $(window).scroll(function(){  
			inViewport();
		  });
		  
		  $(window).resize(function(){
			inViewport();
		  });

	};
	
	return {
		init: init
	};
	
})();

export default Animations;
	